import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import ExpertiseImage from "../../assets/ExpertiseOne.jpg";
import ExpertImages from "../../assets/expert-images.webp";
import Manufacturing from "../../assets/Manufacturing.jpg";
import ExpertiseLastBG from "../../assets/ExpertiseLastBG.jpg";

const Expertise = () => {
  const handleTalkToTeam = () => {
    window.location.href = "/contact-us";
  };

  return (
    <>
      <Helmet>
        <title>Medichy | Expertise</title>
        <meta
          name="description"
          content="Medichy offers comprehensive medical device manufacturing services with expertise in minimally invasive devices, catheter technologies, and regulatory compliance."
        />
      </Helmet>
      <TheExpertise>
        <div className="expertise-hero-section">
          <div className="overlay"></div>
          <div className="hero-image">
            <img src={ExpertiseImage} alt="expertiseHeroImage" />
          </div>
          <div className="hero-content">
            <h3 className="expertise-hero-header">Medical Device Expertise</h3>
            <p>
              Decades of experience in minimally invasive device design,
              development, and manufacturing
            </p>
          </div>
        </div>

        <div className="container">
          <div className="expertise-minimally">
            <div className="section-header">
              <h3>
                Minimally Invasive Medical Device Design and Manufacturing
              </h3>
              <p className="section-subtitle">
                Our expertise can help get your idea for a new or upgraded
                medical device product to the final prototype stage ready for
                clinical trials. We can also provide expert services and advice
                as you seek regulatory approval for your device, and we have
                experience supporting the launch of medical device products in
                new marketplaces.
              </p>
              <p className="section-description">
                You can also benefit from our wide-ranging production
                capabilities where we specialize in manufacturing precision
                components and complete medical device products. Our
                manufacturing plants feature advanced equipment, multiple clean
                room facilities, and skilled production personnel. Our
                capabilities range from small batch manufacturing for clinical
                trials and similar product development purposes through to
                scale-up manufacturing as part of your commercialization
                strategy.
                <br />
                <br />
                We have a proven track record in the design, development, and
                manufacture of advanced catheter technologies, needles and
                similar precision steel components, and guide wires.{" "}
                <a href="/contact-us" className="highlight-link">
                  Get in touch today
                </a>{" "}
                to discuss your requirements.
              </p>
            </div>
          </div>

          <div className="expert-support-project">
            <div className="section-header">
              <h3>Expert Support for Your Project</h3>
            </div>

            <div className="support-grid">
              <div className="write-ups">
                <ul>
                  <li>
                    <div className="list-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                      </svg>
                    </div>
                    <div className="list-content">
                      <h4>Advanced Catheter Technologies</h4>
                      <p>
                        Catheter design services for interventional and
                        diagnostic catheters, including complex and novel
                        devices utilising the latest materials and technologies.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="list-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                      </svg>
                    </div>
                    <div className="list-content">
                      <h4>Needles, Stylets, and Cannulas</h4>
                      <p>
                        We design and manufacture precision steel components for
                        medical device products, including specialist needles.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="list-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                      </svg>
                    </div>
                    <div className="list-content">
                      <h4>Guidewires</h4>
                      <p>
                        When an off-the-shelf guidewire doesn't deliver the
                        performance characteristics you require, we can design
                        and manufacture a bespoke solution that will set your
                        product apart from the competition while improving
                        outcomes for patients.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="expert-images-side-by-side">
                <div className="expert-image">
                  <img src={ExpertImages} alt="expert-image" />
                  <div className="image-overlay-card"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="customized-expert-grid">
            <div className="section-header">
              <h3>
                Customised Medical Device Design and Manufacturing Solutions
              </h3>
              <p className="section-subtitle">
                You can expect a fully bespoke solution when you come to us at
                Medichy. Plus, we have decades of experience providing design
                and manufacturing support to companies of all sizes in the
                medical device industry.
              </p>
            </div>

            <div className="grid-container">
              <div className="grid-item">
                <div className="content-image">
                  <img src={Manufacturing} alt="manufacturing process" />
                  <div className="image-overlay-card"></div>
                </div>
                <div className="content">
                  <h4>End-to-End Solutions</h4>
                  <p>
                    From initial concept through to full-scale production, we
                    provide comprehensive support at every stage of your medical
                    device journey.
                  </p>
                </div>
              </div>

              <div className="grid-item">
                <div className="content">
                  <h4>Industry Experience</h4>
                  <p>
                    Decades of experience working with startups through to
                    established OEMs across various medical specialties and
                    device categories.
                  </p>
                </div>
                <div className="content-image">
                  <img src={ExpertiseLastBG} alt="manufacturing expertise" />
                  <div className="image-overlay-card"></div>
                </div>
              </div>
            </div>

            <div className="consultation-section">
              <div className="consultation-content">
                <h4>Arrange a Consultation</h4>
                <p>
                  To speak to us in complete confidence about the advice or
                  practical support that you need,{" "}
                  <a href="/contact-us" className="highlight-link">
                    please get in touch to arrange a consultation with our
                    engineers.
                  </a>
                </p>
                <button className="btn-secondary" onClick={handleTalkToTeam}>
                  SCHEDULE A CONSULTATION
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* <div className="get-intouch">
            <div className="get-intouch-content">
              <h3>Ready to Discuss Your Project?</h3>
              <p>
                Contact our expert team today to learn how we can help bring
                your medical device concept to life with our comprehensive
                design and manufacturing capabilities.
              </p>
              <button className="btn-primary" onClick={handleTalkToTeam}>
                GET IN TOUCH
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>
          </div> */}
        </div>
      </TheExpertise>
    </>
  );
};

const TheExpertise = styled.div`
  width: 100%;
  min-height: 100vh;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .expertise-hero-section {
    position: relative;
    height: 60vh;
    width: 100%;
    overflow: hidden;
    margin-bottom: 4rem;

    .hero-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.85) 0%,
        rgba(0, 50, 150, 0.9) 100%
      );
      z-index: 1;
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 900px;
      padding: 0 1rem;
      z-index: 2;

      .expertise-hero-header {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 1.5rem;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        line-height: 1;
      }

      p {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        line-height: 1.6;
        max-width: 800px;
        margin: 0 auto;
      }
    }
  }

  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 1rem;
    }

    .section-subtitle {
      font-size: 1.25rem;
      color: #666;
      line-height: 1.6;
      max-width: 900px;
      margin: 0 auto 1.5rem;
    }

    .section-description {
      font-size: 1.1rem;
      color: #666;
      line-height: 1.6;
      max-width: 900px;
      margin: 0 auto;

      .highlight-link {
        color: #3182ce;
        font-weight: 600;
        text-decoration: none;
        border-bottom: 2px solid transparent;
        transition: all 0.3s ease;

        &:hover {
          border-bottom-color: #3182ce;
        }
      }
    }
  }

  .expertise-minimally {
    padding: 4rem 0;
  }

  .expert-support-project {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .support-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: start;

      .write-ups {
        ul {
          list-style: none;
          padding: 0;

          li {
            display: flex;
            gap: 1.5rem;
            margin-bottom: 2.5rem;
            padding: 1.5rem;
            background: white;
            border-radius: 16px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-4px);
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
            }

            &:last-child {
              margin-bottom: 0;
            }

            .list-icon {
              width: 50px;
              height: 50px;
              background: linear-gradient(135deg, #3182ce, #2c5282);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              color: white;
              font-size: 1.25rem;
            }

            .list-content {
              h4 {
                font-size: 1.25rem;
                font-weight: 700;
                color: #1a1a1a;
                margin-bottom: 0.5rem;
              }

              p {
                font-size: 1rem;
                color: #666;
                line-height: 1.6;
                margin: 0;
              }
            }
          }
        }
      }

      .expert-images-side-by-side {
        .expert-image {
          position: relative;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
          height: 450px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
          }

          .image-overlay-card {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              to right,
              rgba(0, 100, 200, 0.1),
              transparent
            );
          }

          &:hover img {
            transform: scale(1.05);
          }
        }
      }
    }
  }

  .customized-expert-grid {
    padding: 4rem 0;

    .grid-container {
      display: grid;
      grid-template-columns: 1fr;
      gap: 3rem;
      margin: 3rem 0 4rem;

      .grid-item {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 4rem;
        align-items: center;
        padding: 2rem;
        background: white;
        border-radius: 20px;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        border: 1px solid #e2e8f0;

        &:nth-child(even) {
          .content-image {
            order: 2;
          }

          .content {
            order: 1;
          }
        }

        .content-image {
          position: relative;
          border-radius: 12px;
          overflow: hidden;
          height: 300px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
          }

          .image-overlay-card {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              to right,
              rgba(0, 100, 200, 0.1),
              transparent
            );
          }

          &:hover img {
            transform: scale(1.05);
          }
        }

        .content {
          h4 {
            font-size: 1.75rem;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 1rem;
            position: relative;
            display: inline-block;

            &:after {
              content: "";
              position: absolute;
              bottom: -8px;
              left: 0;
              width: 60px;
              height: 4px;
              background: linear-gradient(135deg, #3182ce, #2c5282);
              border-radius: 2px;
            }
          }

          p {
            font-size: 1.1rem;
            color: #666;
            line-height: 1.6;
            margin-top: 1.5rem;
          }
        }
      }
    }

    .consultation-section {
      background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%);
      border-radius: 20px;
      padding: 3rem;
      text-align: center;
      border: 2px solid #bae6fd;

      .consultation-content {
        max-width: 700px;
        margin: 0 auto;

        h4 {
          font-size: 2rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1.1rem;
          color: #666;
          line-height: 1.6;
          margin-bottom: 2rem;

          .highlight-link {
            color: #3182ce;
            font-weight: 600;
            text-decoration: none;
            border-bottom: 2px solid transparent;
            transition: all 0.3s ease;

            &:hover {
              border-bottom-color: #3182ce;
            }
          }
        }

        .btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
          color: white;
          border: none;
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

            svg {
              transform: translateX(5px);
            }
          }

          svg {
            transition: transform 0.3s ease;
          }
        }
      }
    }
  }

  .get-intouch {
    position: relative;
    padding: 6rem 0;
    margin: 4rem 0;
    border-radius: 24px;
    overflow: hidden;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.85) 0%,
        rgba(0, 50, 150, 0.9) 100%
      );
      z-index: 1;
    }

    .get-intouch-content {
      position: relative;
      z-index: 2;
      text-align: center;
      color: white;
      max-width: 800px;
      margin: 0 auto;
      padding: 0 1rem;

      h3 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 1.5rem;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
      }

      p {
        font-size: 1.25rem;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        margin-bottom: 2.5rem;
        line-height: 1.6;
      }

      .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: white;
        color: #3182ce;
        border: none;
        padding: 1.25rem 3rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: #f7fafc;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    .expertise-hero-section {
      height: 55vh;

      .hero-content {
        .expertise-hero-header {
          font-size: 3.25rem;
        }

        p {
          font-size: 1.4rem;
        }
      }
    }

    .container {
      padding: 0 1.5rem;
    }

    .section-header {
      h3 {
        font-size: 2.25rem;
      }
    }

    .expert-support-project {
      .support-grid {
        gap: 3rem;

        .expert-images-side-by-side {
          .expert-image {
            height: 400px;
          }
        }
      }
    }

    .customized-expert-grid {
      .grid-container {
        .grid-item {
          gap: 3rem;

          .content-image {
            height: 280px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .expertise-hero-section {
      height: 50vh;

      .hero-content {
        .expertise-hero-header {
          font-size: 3rem;
        }

        p {
          font-size: 1.3rem;
        }
      }
    }

    .expert-support-project {
      .support-grid {
        .expert-images-side-by-side {
          .expert-image {
            height: 350px;
          }
        }
      }
    }

    .customized-expert-grid {
      .grid-container {
        .grid-item {
          gap: 2.5rem;
          padding: 1.5rem;

          .content-image {
            height: 250px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    .expertise-hero-section {
      height: 45vh;
      margin-bottom: 3rem;

      .hero-content {
        .expertise-hero-header {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.1rem;
        }
      }
    }

    .container {
      padding: 0 1rem;
    }

    .section-header {
      margin-bottom: 3rem;

      h3 {
        font-size: 2rem;
      }

      .section-subtitle {
        font-size: 1.1rem;
      }

      .section-description {
        font-size: 1rem;
      }
    }

    .expertise-minimally {
      padding: 3rem 0;
    }

    .expert-support-project {
      padding: 3rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .support-grid {
        grid-template-columns: 1fr;
        gap: 3rem;

        .expert-images-side-by-side {
          .expert-image {
            height: 300px;
            order: 1;
          }
        }

        .write-ups {
          order: 2;

          ul {
            li {
              flex-direction: column;
              gap: 1rem;
              padding: 1.25rem;
              margin-bottom: 1.5rem;

              .list-icon {
                width: 45px;
                height: 45px;
                font-size: 1.1rem;
              }

              .list-content {
                h4 {
                  font-size: 1.1rem;
                }

                p {
                  font-size: 0.95rem;
                }
              }
            }
          }
        }
      }
    }

    .customized-expert-grid {
      padding: 3rem 0;

      .grid-container {
        margin: 2rem 0 3rem;

        .grid-item {
          grid-template-columns: 1fr;
          gap: 2rem;
          padding: 1.5rem;

          &:nth-child(even) {
            .content-image {
              order: 1;
            }

            .content {
              order: 2;
            }
          }

          .content-image {
            height: 220px;
            order: 1;
          }

          .content {
            order: 2;

            h4 {
              font-size: 1.5rem;
            }

            p {
              font-size: 1rem;
            }
          }
        }
      }

      .consultation-section {
        padding: 2rem;

        .consultation-content {
          h4 {
            font-size: 1.75rem;
          }

          p {
            font-size: 1rem;
          }

          .btn-secondary {
            padding: 0.875rem 2rem;
            font-size: 1rem;
          }
        }
      }
    }

    .get-intouch {
      padding: 4rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .get-intouch-content {
        h3 {
          font-size: 2rem;
        }

        p {
          font-size: 1.1rem;
        }

        .btn-primary {
          padding: 1rem 2.5rem;
          font-size: 1rem;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .expertise-hero-section {
      height: 100vh;

      .hero-content {
        .expertise-hero-header {
          font-size: 2rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
        }
      }
    }

    .section-header {
      margin-bottom: 2.5rem;

      h3 {
        font-size: 1.75rem;
      }

      .section-subtitle {
        font-size: 1rem;
      }

      .section-description {
        font-size: 0.95rem;
      }
    }

    .expertise-minimally {
      padding: 2.5rem 0;
    }

    .expert-support-project {
      padding: 2.5rem 0;
      margin: 2.5rem 0;

      .support-grid {
        .expert-images-side-by-side {
          .expert-image {
            height: 250px;
          }
        }

        .write-ups {
          ul {
            li {
              padding: 1rem;
              margin-bottom: 1.25rem;

              .list-icon {
                width: 40px;
                height: 40px;
                font-size: 1rem;
              }

              .list-content {
                h4 {
                  font-size: 1rem;
                }

                p {
                  font-size: 0.9rem;
                }
              }
            }
          }
        }
      }
    }

    .customized-expert-grid {
      padding: 2.5rem 0;

      .grid-container {
        .grid-item {
          padding: 1.25rem;

          .content-image {
            height: 200px;
          }

          .content {
            h4 {
              font-size: 1.25rem;
            }

            p {
              font-size: 0.95rem;
            }
          }
        }
      }

      .consultation-section {
        padding: 1.5rem;

        .consultation-content {
          h4 {
            font-size: 1.5rem;
          }

          p {
            font-size: 0.95rem;
            margin-bottom: 1.5rem;
          }

          .btn-secondary {
            padding: 0.75rem 1.5rem;
            font-size: 0.95rem;
          }
        }
      }
    }

    .get-intouch {
      padding: 3rem 0;
      margin: 2.5rem 0;

      .get-intouch-content {
        h3 {
          font-size: 1.75rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 2rem;
        }

        .btn-primary {
          padding: 0.875rem 2rem;
          font-size: 0.95rem;
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    .expertise-hero-section {
      height: 35vh;

      .hero-content {
        .expertise-hero-header {
          font-size: 1.75rem;
        }

        p {
          font-size: 0.9rem;
        }
      }
    }

    .section-header {
      h3 {
        font-size: 1.5rem;
      }

      .section-subtitle {
        font-size: 0.9rem;
      }

      .section-description {
        font-size: 0.9rem;
      }
    }

    .expert-support-project {
      .support-grid {
        .expert-images-side-by-side {
          .expert-image {
            height: 200px;
          }
        }

        .write-ups {
          ul {
            li {
              .list-icon {
                width: 35px;
                height: 35px;
                font-size: 0.9rem;
              }

              .list-content {
                h4 {
                  font-size: 0.95rem;
                }

                p {
                  font-size: 0.85rem;
                }
              }
            }
          }
        }
      }
    }

    .customized-expert-grid {
      .grid-container {
        .grid-item {
          .content-image {
            height: 180px;
          }

          .content {
            h4 {
              font-size: 1.1rem;
            }

            p {
              font-size: 0.9rem;
            }
          }
        }
      }

      .consultation-section {
        padding: 1rem;

        .consultation-content {
          h4 {
            font-size: 1.25rem;
          }

          p {
            font-size: 0.9rem;
          }

          .btn-secondary {
            padding: 0.625rem 1.25rem;
            font-size: 0.85rem;
          }
        }
      }
    }

    .get-intouch {
      .get-intouch-content {
        h3 {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-primary {
          padding: 0.75rem 1.5rem;
          font-size: 0.9rem;
        }
      }
    }
  }

  @media screen and (max-width: 350px) {
    .expertise-hero-section {
      height: 30vh;

      .hero-content {
        .expertise-hero-header {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.85rem;
        }
      }
    }

    .section-header {
      h3 {
        font-size: 1.25rem;
      }

      .section-subtitle {
        font-size: 0.85rem;
      }

      .section-description {
        font-size: 0.85rem;
      }
    }

    .expert-support-project {
      .support-grid {
        .expert-images-side-by-side {
          .expert-image {
            height: 180px;
          }
        }

        .write-ups {
          ul {
            li {
              .list-icon {
                width: 30px;
                height: 30px;
                font-size: 0.8rem;
              }

              .list-content {
                h4 {
                  font-size: 0.9rem;
                }

                p {
                  font-size: 0.8rem;
                }
              }
            }
          }
        }
      }
    }

    .customized-expert-grid {
      .grid-container {
        .grid-item {
          .content-image {
            height: 160px;
          }

          .content {
            h4 {
              font-size: 1rem;
            }

            p {
              font-size: 0.85rem;
            }
          }
        }
      }

      .consultation-section {
        .consultation-content {
          h4 {
            font-size: 1.1rem;
          }

          p {
            font-size: 0.85rem;
          }

          .btn-secondary {
            padding: 0.5rem 1rem;
            font-size: 0.8rem;

            svg {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }

    .get-intouch {
      .get-intouch-content {
        h3 {
          font-size: 1.25rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-primary {
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
`;

export default Expertise;
